module.exports = __webpack_public_path__ + "static/media/ios-beaker.00f085e7.svg";